/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicineInactivateAliases {
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_INACTIVATE = 'button-inactivate',
  FIELD_INACTIVATE = 'field-inactivate',
  FORM_MEDICINE_INACTIVATE = 'form-medicine-inactivate',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INPUT_INACTIVATE = 'input-inactivate',
  LAYOUT_MEDICINE_INACTIVATE = 'layout-medicine-inactivate',
  PANEL_MEDICINE_INACTIVATE = 'panel-medicine-inactivate',
}
export { MyChartMedicineInactivateAliases };
